/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const jobSectionStyle = {
  container: {
    textAlign: "center",
  },
  heading: {
    textAlign: "center",
    marginTop: "1rem",
    marginBottom: "1rem",
  },
  description: {
    textAlign: { xs: "left", md: "center" },
    marginBottom: "2rem",
  },
  categoryHeader: {
    alignItems: "center",
    marginBottom: "1rem",
  },
  categoryDivider: (theme: Theme) => ({
    flexGrow: 1,
    borderColor: theme.palette.primaryPale,
  }),
  job: {
    minWidth: 0,
    padding: "1.5rem",
    margin: "1rem 0",
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    alignItems: { xs: "flex-start", sm: "center" },
    justifyContent: "space-between",
    gap: { xs: "1rem", sm: 0 },
  },
  jobTitle: {
    textAlign: "left",
    overflowWrap: "anywhere",
  },
};

export default jobSectionStyle;
